import {toast} from "react-toastify";
import {
  IconAlertCircle,
  IconPhoneX
} from "@tabler/icons-react";
import React from "react";
import {
  CallEnd,
  Check,
  PhoneCallback,
  PhoneDisabled,
  PhoneForwarded,
  PhoneInTalk,
  PhoneMissed
} from "@mui/icons-material";
import {green, red, orange, lightBlue, blue} from "@mui/material/colors";

export const copyToClipboard = async (data) => {
  try {
    await navigator.clipboard.writeText(data);
  } catch (error) {
    toast.error("Error copying URL")
  }
}

export const mapToUrl = (path, baseUrl = "") => {
  return new URL(path, baseUrl).toString();
}

export const getConversationIcon = (status) => {
  return {
    "ACTIVE": <PhoneInTalk sx={{fontSize: 21, color: green[400]}} className={"phone-shake"} />,
    "FINISHED": <CallEnd sx={{fontSize: 21, color: "info.dark"}} />,
    "SUCCESS": <Check sx={{fontSize: 21, color: green[700]}} />,
    "REDIRECTED": <PhoneForwarded sx={{fontSize: 21}} color={"warning"} />,
    "FAILED": <IconPhoneX sx={{fontSize: 21}} color={"rgb(211, 47, 47)"} />,
    "HANDOVER": <PhoneForwarded sx={{fontSize: 21}} color={"info"} />,
    "HANGUP": <PhoneDisabled sx={{fontSize: 21, color: "info.dark"}} />,
    "MISSED_CALL": <PhoneMissed sx={{fontSize: 21}} className={"phone-shake"} color={"error"} />,
    "AGENT_CALL_INITIATED": <PhoneCallback sx={{fontSize: 21, color: green[500]}} />,
    "USER_NOT_TALKING": <IconAlertCircle color={orange[700]} sx={{fontSize: 21, color: orange[500]}} />,
  }[status]
}

export const getBgColorIcon = (status) => {
  return {
    "ACTIVE": green[50],
    "FINISHED": lightBlue[50],
    "SUCCESS": green[100],
    "REDIRECTED": orange[100],
    "FAILED": red[100],
    "HANDOVER": lightBlue[50],
    "HANGUP": blue[100],
    "MISSED_CALL": red[100],
    "AGENT_CALL_INITIATED": green[50],
    "USER_NOT_TALKING": orange[50],
  }[status]
}

export function validatePasswordStrength(password) {
  const errors = [];

  if (password.length < 6 || password.length > 127) {
    errors.push("Password must be between 10 and 127 characters.");
  }
  if (!/\d/.test(password)) {
    errors.push("Password must contain at least one number.");
  }
  if (!(/[a-z]/.test(password) && /[A-Z]/.test(password))) {
    errors.push("Password must contain both uppercase and lowercase letters.");
  }
  if (!/[!#@$%^&*)(+=._-]/.test(password)) {
    errors.push("Password must contain at least one special character.");
  }
  return errors;
}

export const formatTime = (sec) => {
  const minutes = Math.floor(sec / 60);
  const seconds = Math.floor(sec % 60).toString().padStart(2, '0');
  return `${minutes}:${seconds}`;
};

export default function isElectron() {
  return (window && window.process && window.process.type === 'renderer') || (navigator.userAgent.toLowerCase().includes('electron'))
}